import {
  ConfirmationEduRequest,
  type EduConfirmationStatus,
} from "../components/ConfirmationEduRequest/ConfirmationEduRequest";
import useUrlHelper from "../hooks/urlHelper";

const EduRequestConfirmationPage = () => {
  const urlHelper = useUrlHelper();

  return (
    <ConfirmationEduRequest
      status={urlHelper.getQueryParams()["status"] as EduConfirmationStatus}
    />
  );
};

export default EduRequestConfirmationPage;
